import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { LayoutPlain, Header, Footer } from 'components/layout'
import { meta } from 'helpers/decorators'
import { apiEmails } from 'helpers/decorators/api'
import queryString from 'query-string'
import { ACCOUNT_TYPES } from '../../../constants/enums'

@meta({ title: 'Re-activate account', intlKey: 'route.reactivate_account' })
@apiEmails()
class ReactivateAccount extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    reactivateAccount: PropTypes.func.isRequired
  }

  componentDidMount() {
    const query = queryString.parse(this.props.location.search)

    this.props.reactivateAccount(get(query, 'authorizationCode'), ACCOUNT_TYPES.participant.id)
  }

  render() {
    const content = (
      <h1 className="beta text--center">
        <FormattedMessage
          id="moduleTitle.reactivate_account"
          defaultMessage="Re-activate account"
        />
      </h1>
    )

    return (
      <LayoutPlain
        header={<Header />}
        footer={<Footer />}
        body={[content]}
        colWidth="320px"
      />
    )
  }
}

export default ReactivateAccount
